import { render, staticRenderFns } from "./card-detail-deal.vue?vue&type=template&id=66efeed0&scoped=true"
import script from "./card-detail-deal.vue?vue&type=script&lang=js"
export * from "./card-detail-deal.vue?vue&type=script&lang=js"
import style0 from "./card-detail-deal.vue?vue&type=style&index=0&id=66efeed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66efeed0",
  null
  
)

export default component.exports